import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Lietuvi\u0173",
  code: "lt",
  messages: {
    alert: {
      close: "U\u017Edaryti"
    },
    authForm: {
      hidePassword: "Sl\u0117pti slapta\u017Eod\u012F",
      showPassword: "Rodyti slapta\u017Eod\u012F",
      submit: "T\u0119sti"
    },
    banner: {
      close: "U\u017Edaryti"
    },
    calendar: {
      nextMonth: "Kitas m\u0117nuo",
      nextYear: "Kiti metai",
      prevMonth: "Ankstesnis m\u0117nuo",
      prevYear: "Ankstesni metai"
    },
    carousel: {
      dots: "Pasirinkite skaidr\u0119 rodymui",
      goto: "Eiti \u012F skaidr\u0119 {slide}",
      next: "Pirmyn",
      prev: "Atgal"
    },
    chatPrompt: {
      placeholder: "\u012Eveskite savo \u017Einut\u0119 \u010Dia..."
    },
    chatPromptSubmit: {
      label: "Si\u0173sti \u017Einut\u0119"
    },
    colorMode: {
      dark: "Tamsus",
      light: "\u0160viesus",
      switchToDark: "Perjungti \u012F tams\u0173 re\u017Eim\u0105",
      switchToLight: "Perjungti \u012F \u0161vies\u0173 re\u017Eim\u0105",
      system: "Sistema"
    },
    commandPalette: {
      back: "Atgal",
      close: "U\u017Edaryti",
      noData: "N\u0117ra duomen\u0173",
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173",
      placeholder: "\u012Eveskite komand\u0105 arba ie\u0161kokite..."
    },
    contentSearch: {
      links: "Nuorodos",
      theme: "Tema"
    },
    contentSearchButton: {
      label: "Ie\u0161koti..."
    },
    contentToc: {
      title: "\u0160iame puslapyje"
    },
    dashboardSearch: {
      theme: "Tema"
    },
    dashboardSearchButton: {
      label: "Ie\u0161koti..."
    },
    dashboardSidebarCollapse: {
      collapse: "Suskleisti \u0161onin\u0119 juost\u0105",
      expand: "I\u0161pl\u0117sti \u0161onin\u0119 juost\u0105"
    },
    dashboardSidebarToggle: {
      close: "U\u017Edaryti \u0161onin\u0119 juost\u0105",
      open: "Atidaryti \u0161onin\u0119 juost\u0105"
    },
    error: {
      clear: "Gr\u012F\u017Eti \u012F prad\u017Ei\u0105"
    },
    fileUpload: {
      removeFile: "Pa\u0161alinti {filename}"
    },
    header: {
      close: "U\u017Edaryti meniu",
      open: "Atidaryti meniu"
    },
    inputMenu: {
      create: 'Sukurti \u201E{label}"',
      noData: "N\u0117ra duomen\u0173",
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173"
    },
    inputNumber: {
      decrement: "Suma\u017Einti",
      increment: "Padidinti"
    },
    modal: {
      close: "U\u017Edaryti"
    },
    pricingTable: {
      caption: "Kain\u0173 plan\u0173 palyginimas"
    },
    prose: {
      codeCollapse: {
        closeText: "Suskleisti",
        name: "kodas",
        openText: "I\u0161pl\u0117sti"
      },
      collapsible: {
        closeText: "Sl\u0117pti",
        name: "savyb\u0117s",
        openText: "Rodyti"
      },
      pre: {
        copy: "Kopijuoti kod\u0105 \u012F i\u0161karpin\u0119"
      }
    },
    selectMenu: {
      create: 'Sukurti \u201E{label}"',
      noData: "N\u0117ra duomen\u0173",
      noMatch: "N\u0117ra atitinkan\u010Di\u0173 duomen\u0173",
      search: "Ie\u0161koti..."
    },
    slideover: {
      close: "U\u017Edaryti"
    },
    table: {
      noData: "N\u0117ra duomen\u0173"
    },
    toast: {
      close: "U\u017Edaryti"
    }
  }
});
